import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";

import Feedback from "../pages/Feedback";
import { RequirementList } from "../pages/RequirementList";
const RequirementDetails = lazy(() => import("../pages/RequirementDetails"));
const PurchaseOpportunity = lazy(() => import("../pages/NewPurchaseOpportunity"));
import Page404 from "../pages/Page404";
import Login from "../pages/Login";
const CapabilityAnalysis = lazy(() => import("../pages/CapabilityAnalysis"));
const RawMaterialsPage = lazy(() => import("../pages/RawMaterialsPage"));

import Header from "../components/Header";
import ApprovedFeedstock from "../pages/ApprovedFeedstock";
import FeedstockQualityPage from "../pages/FeedstockQuality";
import PageLoaderWrapper from "./style";
import Loader from "../components/Loader";

const PageLoader = () => {
  return (
    <PageLoaderWrapper>
      <Loader />
    </PageLoaderWrapper>
  );
};

const App = (): JSX.Element => {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  if (inProgress !== "none") {
    return <Feedback feedback={inProgress} />;
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<RequirementList />} />
        <Route
          path="/opportunity/:requirementId/*"
          element={(
            <Suspense fallback={<PageLoader />}>
              <RequirementDetails />
            </Suspense>
          )}
        />
        <Route
          path="/new-opportunity/*"
          element={(
            <Suspense fallback={<PageLoader />}>
              <PurchaseOpportunity />
            </Suspense>
          )}
        />
        <Route
          path="/capability-analysis"
          element={(
            <Suspense fallback={<PageLoader />}>
              <CapabilityAnalysis />
            </Suspense>
          )}
        />
        <Route
          path="/raw-materials"
          element={(
            <Suspense fallback={<PageLoader />}>
              <RawMaterialsPage />
            </Suspense>
          )}
        />
        <Route
          path="/approved-feedstock"
          element={(
            <Suspense fallback={<PageLoader />}>
              <ApprovedFeedstock />
            </Suspense>
          )}
        />
        <Route
          path="/feedstock-quality"
          element={(
            <Suspense fallback={<PageLoader />}>
              <FeedstockQualityPage />
            </Suspense>
          )}
        />
        <Route path="/*" element={<Page404 />} />
      </Routes>
    </>
  );
};

export default App;
